import React, { useContext, useState, useEffect } from "react";
import "../assets/css/layouts/seller/SellerLayout.css";
import SellerSidebar from "../components/seller/sidebar/SellerSidebar";
import SellerTopbar from "../components/seller/topbar/SellerTopbar";
import MyContext from "../context/MyContext";

const SellerLayout = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
  const { setAuthToken, setLoggedInSeller } = useContext(MyContext);
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 991;
      setIsMobile(mobile);
      if (!mobile) setIsMobileOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    const authToken = localStorage.getItem("authToken");
    setAuthToken(authToken);
    let seller = localStorage.getItem("loggedInSeller");
    console.log(seller);
    if (seller != undefined) {
      console.log(seller);
      setLoggedInSeller(JSON.parse(localStorage.getItem("loggedInSeller")));
    }
  }, []);

  return (
    <div className="sel-layout">
      <SellerSidebar
        isCollapsed={isCollapsed}
        setIsCollapsed={setIsCollapsed}
        isMobileOpen={isMobileOpen}
        setIsMobileOpen={setIsMobileOpen}
        isMobile={isMobile}
      />
      <div
        className={[
          "sel-main",
          !isMobile && isCollapsed ? "sel-main--collapsed" : "",
          isMobile ? "sel-main--mobile" : "",
        ]
          .filter(Boolean)
          .join(" ")}
      >
        <SellerTopbar
          isCollapsed={isCollapsed}
          setIsCollapsed={setIsCollapsed}
          isMobileOpen={isMobileOpen}
          setIsMobileOpen={setIsMobileOpen}
          isMobile={isMobile}
        />
        <div className="sel-content">{children}</div>
      </div>
    </div>
  );
};

export default SellerLayout;
